// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityDiagram_NodeConfigurationFragment = { __typename?: 'EntityGraphNodeConfiguration', nodeID: string, xPosition?: number | null, yPosition?: number | null, type?: string | null, iconShape?: string | null, tileEmphasis?: string | null, notes?: string | null, width?: number | null, height?: number | null, fontSize?: string | null, dimensionsFinalized?: boolean | null, entityDiagramConfig?: { __typename?: 'EntityDiagramNodeConfig', hideGroupContents: boolean } | null };

export type EntityDiagram_EntityDiagramFragment = { __typename?: 'EntityDiagram', id: string, kind: Types.EntityDiagramKind, hideEntitiesListInGroups: boolean, visualizationGroups: { __typename?: 'GraphVisualizationGroupConnection', edges?: Array<{ __typename?: 'GraphVisualizationGroupEdge', node?: { __typename?: 'GraphVisualizationGroup', id: string, namespace?: string | null, displayName?: string | null, description?: string | null, nodeIds: Array<string> } | null } | null> | null }, firstGrantorDeath?: { __typename?: 'ClientProfile', id: string } | null, nodeConfigurations: Array<(
    { __typename?: 'EntityGraphNodeConfiguration' }
    & EntityDiagram_NodeConfigurationFragment
  )>, entity: { __typename?: 'Entity', id: string } };

export type CreateEntityDiagramMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateEntityDiagramInput;
}>;


export type CreateEntityDiagramMutation = { __typename?: 'Mutation', createEntityDiagram: (
    { __typename?: 'EntityDiagram' }
    & EntityDiagram_EntityDiagramFragment
  ) };

export type UpdateEntityDiagramMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEntityDiagramInput;
}>;


export type UpdateEntityDiagramMutation = { __typename?: 'Mutation', updateEntityDiagram: (
    { __typename?: 'EntityDiagram' }
    & EntityDiagram_EntityDiagramFragment
  ) };

export const Operations = {
  Mutation: {
    CreateEntityDiagram: 'CreateEntityDiagram' as const,
    UpdateEntityDiagram: 'UpdateEntityDiagram' as const
  },
  Fragment: {
    EntityDiagram_NodeConfiguration: 'EntityDiagram_NodeConfiguration' as const,
    EntityDiagram_EntityDiagram: 'EntityDiagram_EntityDiagram' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityDiagram_NodeConfigurationFragmentDoc = gql`
    fragment EntityDiagram_NodeConfiguration on EntityGraphNodeConfiguration {
  nodeID
  xPosition
  yPosition
  type
  iconShape
  tileEmphasis
  notes
  width
  height
  fontSize
  dimensionsFinalized
  entityDiagramConfig {
    hideGroupContents
  }
}
    `;
export const EntityDiagram_EntityDiagramFragmentDoc = gql`
    fragment EntityDiagram_EntityDiagram on EntityDiagram {
  id
  kind
  hideEntitiesListInGroups
  visualizationGroups {
    edges {
      node {
        id
        namespace
        displayName
        description
        nodeIds
      }
    }
  }
  firstGrantorDeath {
    id
  }
  nodeConfigurations {
    ...EntityDiagram_NodeConfiguration
  }
  entity {
    id
  }
}
    ${EntityDiagram_NodeConfigurationFragmentDoc}`;
export const CreateEntityDiagramDocument = gql`
    mutation CreateEntityDiagram($input: AugmentedCreateEntityDiagramInput!) {
  createEntityDiagram(input: $input) {
    ...EntityDiagram_EntityDiagram
  }
}
    ${EntityDiagram_EntityDiagramFragmentDoc}`;
export type CreateEntityDiagramMutationFn = Apollo.MutationFunction<CreateEntityDiagramMutation, CreateEntityDiagramMutationVariables>;

/**
 * __useCreateEntityDiagramMutation__
 *
 * To run a mutation, you first call `useCreateEntityDiagramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityDiagramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityDiagramMutation, { data, loading, error }] = useCreateEntityDiagramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityDiagramMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityDiagramMutation, CreateEntityDiagramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityDiagramMutation, CreateEntityDiagramMutationVariables>(CreateEntityDiagramDocument, options);
      }
export type CreateEntityDiagramMutationHookResult = ReturnType<typeof useCreateEntityDiagramMutation>;
export type CreateEntityDiagramMutationResult = Apollo.MutationResult<CreateEntityDiagramMutation>;
export type CreateEntityDiagramMutationOptions = Apollo.BaseMutationOptions<CreateEntityDiagramMutation, CreateEntityDiagramMutationVariables>;
export const UpdateEntityDiagramDocument = gql`
    mutation UpdateEntityDiagram($input: AugmentedUpdateEntityDiagramInput!) {
  updateEntityDiagram(input: $input) {
    ...EntityDiagram_EntityDiagram
  }
}
    ${EntityDiagram_EntityDiagramFragmentDoc}`;
export type UpdateEntityDiagramMutationFn = Apollo.MutationFunction<UpdateEntityDiagramMutation, UpdateEntityDiagramMutationVariables>;

/**
 * __useUpdateEntityDiagramMutation__
 *
 * To run a mutation, you first call `useUpdateEntityDiagramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityDiagramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityDiagramMutation, { data, loading, error }] = useUpdateEntityDiagramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityDiagramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityDiagramMutation, UpdateEntityDiagramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityDiagramMutation, UpdateEntityDiagramMutationVariables>(UpdateEntityDiagramDocument, options);
      }
export type UpdateEntityDiagramMutationHookResult = ReturnType<typeof useUpdateEntityDiagramMutation>;
export type UpdateEntityDiagramMutationResult = Apollo.MutationResult<UpdateEntityDiagramMutation>;
export type UpdateEntityDiagramMutationOptions = Apollo.BaseMutationOptions<UpdateEntityDiagramMutation, UpdateEntityDiagramMutationVariables>;